var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.renderError)?_c('div',{staticClass:"err-msg notification is-danger is-small is-light"},[_c('button',{staticClass:"delete is-small",on:{"click":function($event){_vm.renderError = false}}}),_vm._v(" "+_vm._s(_vm.err)+" ")]):_vm._e(),_c('h2',[_vm._v("That page cannot be displayed.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }